import { render, staticRenderFns } from "./MediaTypes.vue?vue&type=template&id=288064a6&scoped=true&"
import script from "./MediaTypes.vue?vue&type=script&lang=js&"
export * from "./MediaTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288064a6",
  null
  
)

export default component.exports